import React from 'react';
import { asAppConfigSection } from 'Src/types/server-helpers';
import appConfig from 'Config';
export const Hosting = () => {
  const { pixel } = asAppConfigSection<{ pixel: { enabled: boolean } }>(appConfig.get('hosting'));

  if (pixel.enabled) {
    return (
      <img
        src="https://s3.cn-north-1.amazonaws.com.cn/nscn/pixel.png"
        alt=""
        width="1"
        height="1"
      />
    );
  }

  return null;
};
